<footer *ngIf="card.config.footerHtml">
  <div class="bl-padding-top--16" [innerHTML]="card.config.footerHtml|safe:'html'"></div>
</footer>
